/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isBoolean } from "utils/APIUtils";

const getLHPApis = stores => {
  function show(visible) {
    if (isBoolean(visible)) {
      stores.lhpStore.setLHPVisibility(visible);
      stores.lhpStore.setLHPExplicitlyDisabled(!visible);
    }
  }

  return {
    show
  };
};

export const registerLHPApis = stores => {
  apiFactory.registerApi(publicApiNames.LHP, clientName => getLHPApis(stores), true);
};
